import React, { Component, Fragment } from 'react';
import NumberBox from './../../Misc/NumericBox';
import {currencySymbols} from './currencySymbols';
export default class PaymentGatewayForm extends Component {
    getCurrencySymbol=()=>{
        const {schoolInfo}=this.props;
        return (currencySymbols.find(rec=>{
            return rec.code.includes(schoolInfo.countryCode)
        })||{}).symbol||''

    }
  render() {
      const {gatewayOptions,schoolInfo}=this.props
    return (
      <Fragment>
        <h4>Payment Gateway methods</h4>
        <div className="">
            {
                gatewayOptions.map((item,i)=>{
                    return (
                        <div className="panel panel-default">
                            <div className="panel-heading">
                            <h4 className="panel-title">
                            <input type="checkbox" name="chPayGateway" checked={item.select} onChange={(e)=>{
                                this.props.onPaymentOptionChange(e,i);
                            }} />  {item.name}
                            </h4>
                            </div>
                            <div className={`panel-collapse collapse ${item.select?'in':''}`}>
                                {
                                    (item.formValues.length>0 || item.name==='Stripe')?
                                    <div className="panel-body">
                                        <form>
                                            {
                                                item.name==='Stripe'?
                                                <div className='row form-horizontal'>
                                                    <div className='col-md-4'>
                                                        <div className='row'>
                                                            <div className="form-group">
                                                                <div className='col-sm-offset-1 col-sm-10'>
                                                                    <label><input type="checkbox" name="trxFeeOnSchool" checked={schoolInfo.trxFeeOnSchool} onChange={(e)=>{
                                                                        this.props.onStripeChargesFromMurchant(e);
                                                                    }} /> {'Charges on merchant account'}</label>
                                                                </div>                                                            
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="appFee" className="col-sm-5 control-label">{`Application fee [ ${this.getCurrencySymbol()} ]`}</label>
                                                                <div className="col-sm-7">
                                                                    <NumberBox type="text" className="form-control" maxLength="6" 
                                                                        value={schoolInfo.appFee} 
                                                                        id="appFee" name="appFee" placeholder="0.00"  
                                                                        placeholder="" style={{textAlign:'right'}} 
                                                                        onChange={(e)=>{
                                                                            this.props.onStripeAppFeeChange(e);
                                                                        }} noValidate/>
                                                                </div>
                                                            </div>
                                                        </div>                                                        
                                                    </div>
                                                </div>
                                                    
                                                :
                                                item.formValues.map((f,idx)=>{
                                                    return(
                                                    <div className="form-group">
                                                        <label className='' htmlFor={f.name}>{f.label}</label>
                                                        <input type="text" name={f.name} value={f.value}
                                                        className="form-control" 
                                                        onChange={(e)=>{
                                                            this.props.onChangePaymentFormFieldValue(e,idx);                                                        
                                                        }} />
                                                    </div>)
                                                })

                                            }
                                        </form>
                                    </div>:null
                                }                                
                            </div>
                        </div>
                    )
                })
            }
            </div> 
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperAdmin/AddSchool/paymentGatewayForm.jsx